import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgencyOperatorsComponent } from '../users/agency-operators/agency-operators.component';
import { ModalMode } from '../../../../helpers/modalMode.enum';
import { QueryParams } from '../../../../helpers/queryParams.enum';
import { PataviumRole } from '../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { SessionStorageService } from '../../../../services/session-storage.service';

@Component({
    selector: 'app-agency-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class AgencyDashboardComponent implements OnInit {
    Role = PataviumRole;
    SessionStorageService = SessionStorageService;
    @ViewChild(AgencyOperatorsComponent)
    private agencyOperatorComponent: AgencyOperatorsComponent;

    //linechart contratti
    public lineChartData: Array<any> = [
        { data: [7, 20, 12, 30, 22, 14, 11, 32, 44, 43, 55], label: 'Caricati' },
        { data: [3, 14, 25, 12, 1, 12, 5, 12, 8, 45, 65], label: 'In fornitura' },
        { data: [3, 14, 25, 12, 1, 12, 2, 11, 13, 32, 22], label: 'Ripensamenti' },
        { data: [3, 14, 25, 12, 1, 12, 4, 15, 24, 56, 11], label: 'Annullati' },
        { data: [1, 0, 0, 0, 0, 1, 2, 3, 1, 5, 6], label: 'Recessi' },
        { data: [1, 0, 0, 0, 0, 1, 3, 1, 4, 2, 3], label: 'Rinnovi' }
    ];
    public lineChartData3: Array<any> = [
        { data: [27, 30, 32, 40], label: 'Caricati' },
        { data: [33, 44, 45, 52], label: 'In fornitura' },
        { data: [23, 21, 25, 62], label: 'Ripensamenti' },
        { data: [35, 54, 31, 43], label: 'Annullati' },
        { data: [21, 32, 36, 56], label: 'Recessi' },
        { data: [25, 21, 23, 52], label: 'Rinnovi' }
    ];
    public lineChartData6: Array<any> = [
        { data: [56, 70, 82], label: 'Caricati' },
        { data: [73, 84, 85], label: 'In fornitura' },
        { data: [83, 74, 95], label: 'Ripensamenti' },
        { data: [88, 76, 89], label: 'Annullati' },
        { data: [21, 11, 15], label: 'Recessi' },
        { data: [51, 55, 56], label: 'Rinnovi' }
    ];
    public lineChartData12: Array<any> = [
        { data: [127, 120, 112, 130, 122, 114], label: 'Caricati' },
        { data: [123, 114, 125, 112, 111, 112], label: 'In fornitura' },
        { data: [31, 24, 25, 12, 131, 102], label: 'Ripensamenti' },
        { data: [23, 34, 26, 32, 112, 122], label: 'Annullati' },
        { data: [21, 11, 13, 0, 1, 11], label: 'Recessi' },
        { data: [14, 10, 77, 56, 34, 4], label: 'Rinnovi' }
    ];
    public lineChartLabels: Array<any> = [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre'
    ];
    public lineChartLabels3: Array<any> = [
        'Gennaio-Marzo',
        'Aprile-Giugno',
        'Luglio-Settembre',
        'Ottobre-Dicembre'
    ];
    public lineChartLabels6: Array<any> = [
        'Gennaio-Giugno 2017',
        'Luglio-Dicembre 2017',
        'Gennaio-Giugno 2018'
    ];
    public lineChartLabels12: Array<any> = ['2013', '2014', '2015', '2016', '2017', '2018'];
    public lineChartOptions: any = {
        responsive: true
    };
    public ChartColors: Array<any> = [
        {
            // blue
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#02008C',
            pointBackgroundColor: '#02008C',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#02008C'
        },
        {
            // green
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#00D924',
            pointBackgroundColor: '#00D924',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#00D924'
        },
        {
            // cyan
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#00D6D9',
            pointBackgroundColor: '#00D6D9',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#00D6D9'
        },
        {
            // yellow
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#FFC300',
            pointBackgroundColor: '#FFC300',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#FFC300'
        },
        {
            // red
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#FA0000',
            pointBackgroundColor: '#FA0000',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#FA0000'
        },
        {
            // purple
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#AA00AD',
            pointBackgroundColor: '#AA00AD',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#AA00AD'
        }
    ];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public ChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        plugins: [
            {
                beforeInit: chart => {
                    chart.data.labels.forEach((e, i, a) => {
                        if (/\n/.test(e)) {
                            a[i] = e.split(/\n/);
                        }
                    });
                }
            }
        ]
    };

    //barchart contratti
    public barChartLabels: string[] = [
        'M. Rossi',
        'G. Costantini',
        'A. Neri',
        'F. Bianchi',
        'P. Maldini',
        'R. Guidi',
        'N. \n De Robertis'
    ];
    public barChartType = 'horizontalBar';
    public barChartColors: Array<any> = [
        {
            // blue
            backgroundColor: '#02008C',
            borderColor: '#02008C'
        },
        {
            // green
            backgroundColor: '#00D924',
            borderColor: '#00D924'
        },
        {
            // cyan
            backgroundColor: '#00D6D9',
            borderColor: '#00D6D9'
        },
        {
            // yellow
            backgroundColor: '#FFC300',
            borderColor: '#FFC300'
        },
        {
            // red
            backgroundColor: '#FA0000',
            borderColor: '#FA0000'
        },
        {
            // purple
            backgroundColor: '#AA00AD',
            borderColor: '#AA00AD'
        }
    ];
    public barChartLegend = true;
    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        plugins: [
            {
                beforeInit: chart => {
                    chart.data.labels.forEach((e, i, a) => {
                        if (/\n/.test(e)) {
                            a[i] = e.split(/\n/);
                        }
                    });
                }
            }
        ],
        scales: {
            xAxes: [
                {
                    stacked: true
                }
            ],
            yAxes: [
                {
                    stacked: true
                }
            ]
        }
    };
    public barChartData: any[] = [
        { data: [55, 59, 50, 61, 36, 45, 30], label: 'Caricati' },
        { data: [21, 31, 40, 19, 24, 15, 40], label: 'In fornitura' },
        { data: [11, 8, 0, 1, 1, 3, 1], label: 'Ripensamenti' },
        { data: [3, 1, 1, 9, 4, 7, 9], label: 'Annullati' },
        { data: [1, 1, 3, 5, 5, 3, 1], label: 'Recessi' },
        { data: [9, 0, 6, 5, 30, 27, 19], label: 'Rinnovi' }
    ];
    public barChartData3: any[] = [
        { data: [55, 59, 50, 61, 36, 45, 30], label: 'Caricati' },
        { data: [21, 31, 40, 19, 24, 15, 40], label: 'In fornitura' },
        { data: [11, 8, 0, 1, 1, 3, 1], label: 'Ripensamenti' },
        { data: [3, 1, 1, 9, 4, 7, 9], label: 'Annullati' },
        { data: [1, 1, 3, 5, 5, 3, 1], label: 'Recessi' },
        { data: [9, 0, 6, 5, 30, 27, 19], label: 'Rinnovi' }
    ];
    public barChartData6: any[] = [
        { data: [55, 59, 50, 61, 36, 45, 30], label: 'Caricati' },
        { data: [21, 31, 40, 19, 24, 15, 40], label: 'In fornitura' },
        { data: [11, 8, 0, 1, 1, 3, 1], label: 'Ripensamenti' },
        { data: [3, 1, 1, 9, 4, 7, 9], label: 'Annullati' },
        { data: [1, 1, 3, 5, 5, 3, 1], label: 'Recessi' },
        { data: [9, 0, 6, 5, 30, 27, 19], label: 'Rinnovi' }
    ];
    public barChartData12: any[] = [
        { data: [55, 59, 50, 61, 36, 45, 30], label: 'Caricati' },
        { data: [21, 31, 40, 19, 24, 15, 40], label: 'In fornitura' },
        { data: [11, 8, 0, 1, 1, 3, 1], label: 'Ripensamenti' },
        { data: [3, 1, 1, 9, 4, 7, 9], label: 'Annullati' },
        { data: [1, 1, 3, 5, 5, 3, 1], label: 'Recessi' },
        { data: [9, 0, 6, 5, 30, 27, 19], label: 'Rinnovi' }
    ];

    public paymentbarChartColors: Array<any> = [
        {
            // green
            backgroundColor: '#339900',
            borderColor: '#339900'
        },
        {
            // light green
            backgroundColor: '#99cc33',
            borderColor: '#99cc33'
        },
        {
            // yellow
            backgroundColor: '#ffcc00',
            borderColor: '#ffcc00'
        },
        {
            // pink
            backgroundColor: '#ff9966',
            borderColor: '#ff9966'
        },
        {
            // red
            backgroundColor: '#cc3300',
            borderColor: '#cc3300'
        }
    ];
    public paymentbarChartData: any[] = [
        { data: [45, 59, 50, 61, 56, 55, 40], label: 'Regolari' },
        { data: [20, 1, 20, 19, 11, 15, 20], label: 'In scadenza' },
        { data: [12, 20, 10, 11, 3, 27, 10], label: 'Scaduti (s.s.)' },
        { data: [13, 18, 20, 9, 6, 3, 10], label: 'Scaduti (c.s.)' },
        { data: [10, 2, 0, 0, 24, 0, 20], label: 'Insoluti' }
    ];
    public paymentbarChartData3: any[] = [
        { data: [45, 59, 50, 61, 56, 55, 40], label: 'Regolari' },
        { data: [20, 1, 20, 19, 11, 15, 20], label: 'In scadenza' },
        { data: [12, 20, 10, 11, 3, 27, 10], label: 'Scaduti (s.s.)' },
        { data: [13, 18, 20, 9, 6, 3, 10], label: 'Scaduti (c.s.)' },
        { data: [10, 2, 0, 0, 24, 0, 20], label: 'Insoluti' }
    ];
    public paymentbarChartData6: any[] = [
        { data: [45, 59, 50, 61, 56, 55, 40], label: 'Regolari' },
        { data: [20, 1, 20, 19, 11, 15, 20], label: 'In scadenza' },
        { data: [12, 20, 10, 11, 3, 27, 10], label: 'Scaduti (s.s.)' },
        { data: [13, 18, 20, 9, 6, 3, 10], label: 'Scaduti (c.s.)' },
        { data: [10, 2, 0, 0, 24, 0, 20], label: 'Insoluti' }
    ];
    public paymentbarChartData12: any[] = [
        { data: [45, 59, 50, 61, 56, 55, 40], label: 'Regolari' },
        { data: [20, 1, 20, 19, 11, 15, 20], label: 'In scadenza' },
        { data: [12, 20, 10, 11, 3, 27, 10], label: 'Scaduti (s.s.)' },
        { data: [13, 18, 20, 9, 6, 3, 10], label: 'Scaduti (c.s.)' },
        { data: [10, 2, 0, 0, 24, 0, 20], label: 'Insoluti' }
    ];

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private localStorageService: LocalStorageService
    ) {}

    ngOnInit() {}

    openAgencyOperatorCreationModal() {
        this.router.navigate(['/agency/agency-operators'], {
            queryParams: {
                [QueryParams.ModalMode]: ModalMode.Create
            }
        });
    }

    get agentsRoute() {
        switch (SessionStorageService.sessionInfo.role) {
            case PataviumRole.Agency:
                return '/agency/agents';
            case PataviumRole.AgencyOperator:
                return '/agency-operator/agents';
        }
    }

    get contractRoute() {
        switch (SessionStorageService.sessionInfo.role) {
            case PataviumRole.Agency:
                return '/agency/contracts/contracts';
            case PataviumRole.AgencyOperator:
                return '/agency-operator/contracts/contracts';
        }
    }

    get pricelistsRoute() {
        switch (SessionStorageService.sessionInfo.role) {
            case PataviumRole.Agency:
                return '/agency/sales/pricelists';
            case PataviumRole.AgencyOperator:
                return '/agency-operator/sales/pricelists';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agency/dashboard/dashboard.component.ts